/* tslint:disable */
import { SizingResultEStimation } from './sizing-result-estimation';
import { ViewSizingEstimationResult_dataGraphChart } from './view-sizing-estimation-result-_data-graph-chart';

/**
 */
export class ViewSizingEstimationResult {
    result?: SizingResultEStimation;
    productFlowRate?: number;
    dataGraphChart?: ViewSizingEstimationResult_dataGraphChart;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-sizing-estimation-result.ts